<template>
  <v-card
    outlined
    max-width="400"
    style="height: calc(100vh - 112px); overflow: auto"
    >
    <v-card-text>
      <div
        class="d-flex justify-space-between align-center"
        style="gap: 12px"
        >
        <v-autocomplete
          v-model="properties"
          :items="propertyList"
          item-value="id"
          item-text="fullAddress"
          hide-details
          filled
          dense
          multiple
          chips
          label="Listado de propiedades"
          style="max-width: 314px; max-height: 58px; overflow-y: hidden"
          ></v-autocomplete>
        
        <v-btn
          color="success"
          fab
          depressed
          small
          class="rounded-lg"
          @click="addProperty"
          :disabled="!properties.length"
          >
          <v-icon>
            mdi-plus
          </v-icon>
        </v-btn>
      </div>

      <v-divider
        class="my-3"
        ></v-divider>

      <div>
        <template
          v-for="property in building.properties"
          >
          <property
            :property="property"
            @reload="reload"
            ></property>
        </template>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { FreeProperties } from '@/graphql/queries/buildings'
import { AddPropertiesToBuilding } from '@/graphql/mutations/buildings'

import Property from './Property'

export default {
  data: () => ({
    properties: [],
    propertyList: []
  }),

  props: {
    building: {
      type: Object,
      required: true
    }
  },
  
  created () {
    this.fetchFreeProperties ()
  },

  methods: {
    fetchFreeProperties () {
      this.$apollo.query ({
        query: FreeProperties,
        fetchPolicy: 'no-cache'
      }).then ( res => {
        this.propertyList = res.data.freeProperties
      })
    },

    addProperty () {
      this.$apollo.mutate ({
        mutation: AddPropertiesToBuilding,
        variables: {
          input: {
            id: this.building.id,
            propertyIds: this.properties
          }
        }
      }).then ( res => {
        this.properties = []
        this.fetchFreeProperties ()
        this.$forceUpdate ()
        this.$emit('reload')
      })
    },

    reload () {
      this.fetchFreeProperties ()
      this.$forceUpdate ()
      this.$emit('reload')
    },
  },

  components: {
    Property
  }
}
</script>
